function format(message: string, regexpKey: RegExp, key: string): string {
  if (!message) {
    return '';
  }

  return message.replace(regexpKey, key);
}

export { format };
